import { v4 as uuidv4 } from 'uuid';
import type { TFlowItemFrontend } from '@/types/common.ts';
import {
	getEmptyEditorState,
	normalizeEditorValue
} from '@/utils/editor-conversion';

export const generateFormDefaultValues = (
	flowItem?: Partial<TFlowItemFrontend>
) => ({
	idn: flowItem?.source?.idn ?? uuidv4(),
	mentions: (flowItem?.source?.mentions ?? []).filter(
		(item): item is { item_idn: string; type: string } =>
			typeof item === 'object' && item !== null
	),
	is_from_library: flowItem?.source?.is_from_library ?? false,
	origin_idn: flowItem?.source?.origin_idn ?? '',
	title: normalizeEditorValue(flowItem?.source?.title) ?? getEmptyEditorState(),
	body: normalizeEditorValue(flowItem?.source?.body) ?? getEmptyEditorState()
});
